import React from 'react';

import { Text, BlockStack, InlineStack, Button } from '@shopify/polaris';
import { ICardMediaAsset, MediaAsset, MediaAssetType } from '@/types/media';
import { ViewIcon } from '@shopify/polaris-icons';
import { useUI } from '@/providers/UIProvider';
import { getOutputBucketUrl } from '@/utils/public-urls';
interface MediaMetadataProps {
  media: ICardMediaAsset;
  isActionable?: boolean;
  hideFullScreen?: boolean;
}

const MediaMetadata: React.FC<MediaMetadataProps> = ({ media, hideFullScreen = false }) => {
  const { setMediaAsset } = useUI();
  const handleImageClick = () => {
    setMediaAsset({
      ...media,
      src: media.src || `${getOutputBucketUrl()}/${media.result}`,
    } as MediaAsset);
  };
  return (
    <BlockStack gap="100">
      <InlineStack gap="200" wrap={false} blockAlign="start" align="space-between">
        {media.createdAt && (
          <Text as="p" variant="bodySm" tone="subdued">
            {media.createdAt.slice(0, 10)}
          </Text>
        )}
        {!hideFullScreen && (
          <div className="-translate-y-1">
            <Button icon={ViewIcon} variant="monochromePlain" onClick={handleImageClick} />
          </div>
        )}
      </InlineStack>

      {media.name && (
        <Text as="h2" variant="bodyMd" fontWeight="semibold" truncate>
          {media.name}
        </Text>
      )}
    </BlockStack>
  );
};

export default MediaMetadata;
